import {useExtensionStore} from "@project/app-state";
import {Label, ListBox, Sheet, Typography} from "@project/design-system-web";
import {useI18n} from "@project/i18n/react";

import {appShellMessages} from "../../../messages/app-shell.messages";

import {sidebarExtensionList} from "./extension-sidebar-registry";

interface ExtensionSwitcherProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
}

export function ExtensionSwitcher({isOpen, onOpenChange}: ExtensionSwitcherProps) {
  const {t} = useI18n();
  const activeExtension = useExtensionStore((s) => s.activeExtension);
  const setActiveExtension = useExtensionStore((s) => s.setActiveExtension);

  return (
    <Sheet isOpen={isOpen} onOpenChange={onOpenChange} snapPoints={["260px", "420px"]}>
      <Sheet.Backdrop variant="transparent">
        <Sheet.Content className="mx-auto max-w-90 pb-3">
          <Sheet.Dialog>
            <Sheet.Handle />
            <Sheet.Header>
              <Sheet.Heading>{t(appShellMessages.extensions)}</Sheet.Heading>
              <Typography className="text-muted text-sm">
                {t(appShellMessages.chooseExtensionShortcut)}
              </Typography>
            </Sheet.Header>
            <Sheet.Body className="px-2 pt-0 pb-3">
              <ListBox
                aria-label={t(appShellMessages.extensions)}
                selectedKeys={[activeExtension]}
                selectionMode="single"
                onAction={(key) => {
                  setActiveExtension(String(key));
                  onOpenChange(false);
                }}
              >
                {sidebarExtensionList.map((extension) => {
                  const label = t(extension.labelDescriptor);

                  return (
                    <ListBox.Item key={extension.id} id={extension.id} textValue={label}>
                      <span className="text-muted flex size-5 shrink-0 items-center justify-center">
                        {extension.icon}
                      </span>
                      <Label>{label}</Label>
                      <ListBox.ItemIndicator />
                    </ListBox.Item>
                  );
                })}
              </ListBox>
            </Sheet.Body>
          </Sheet.Dialog>
        </Sheet.Content>
      </Sheet.Backdrop>
    </Sheet>
  );
}
